import { render, staticRenderFns } from "./Ads.vue?vue&type=template&id=73b6b740&scoped=true&"
import script from "./Ads.vue?vue&type=script&lang=ts&"
export * from "./Ads.vue?vue&type=script&lang=ts&"
import style0 from "./Ads.vue?vue&type=style&index=0&id=73b6b740&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b6b740",
  null
  
)

export default component.exports